<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">Configurações &raquo; {{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj mb-3">
                <div class="header">
                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col cols="12" md="4" >
                      <label class="cj-label">Nome da conta</label>
                      <validation-provider name="nome da conta" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="whatsappForm.name" :disabled="!((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off" placeholder="Ex: Dr Paulo, Unid Centro, etc"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="4" v-if="whatsappForm.number !== '' || whatsappForm.status != null">
                      <label class="cj-label">Número</label>
                      <b-form-input type="text" v-model="whatsappForm.number" :disabled="true" autocomplete="off" placeholder="Aguardando conexão..."></b-form-input>
                    </b-col>
                    <b-col cols="12" md="4" v-if="whatsappForm.status != null">
                      <label class="cj-label">Status</label>
                      <div class="whatsapp-status"><i class="fa fa-circle mr-2" :class="'status-indicator ' + getStatus().class"></i>{{getStatus().name}}</div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-3 mb-2">
                    <b-col cols="12" md="8" class="mt-3 mb-4">
                      <table class="table table-responsive table-bordered m-0" style="display: table;">
                        <tbody>
                        <tr>
                          <td>Utilizar a API Oficial do WhatsApp</td>
                          <td class="text-center align-middle">
                            <div class="pretty p-switch p-fill">
                              <input type="checkbox" v-model="whatsappForm.use_official_api" :disabled="!((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit && whatsappForm.status !== 'connected'))" />
                              <div class="state p-success">
                                <label></label>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>

<!--                  TODO mostrar novamente depois, se resolverem cobrar algo-->
                  <b-row v-if="false && whatsappForm.id == null" class="mt-3 mb-2">
                    <b-col>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="whatsappForm.accepted_terms" />
                        <div class="state p-success">
                          <label><span>Estou ciente e de acordo que ao cadastrar uma nova instância será adicionado o valor de R$24,90 (por conta de Whatsapp) na minha assinatura. *</span></label>
                        </div>
                      </div>
                      <div>
                        <label class="cj-label"><span>* Consulte condições para 5 números ou mais.</span></label>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row v-if="whatsappForm.qrcode != null && !whatsappForm.use_official_api" class="mb-2 text-center">
                    <b-col cols="12">
                      <p class="mt-1 mb-0">Abra o aplicativo do Whatsapp e leia o QRCode abaixo para conectar seu número.</p>
                    </b-col>
                    <b-col cols="12">
                      <img :src="whatsappForm.qrcode" alt="QRCode" />
                    </b-col>
                  </b-row>

                  <b-row v-if="whatsappForm.use_official_api && currently_using_official_api" class="mb-2 text-center">
                    <template v-if="whatsappForm.status === null">
                      <b-col cols="12" class="text-center text-md-left mb-3">Configure a API Oficial do WhatsApp Business Meta (Facebook)</b-col>
                      <b-col cols="12" md="8" class="text-center text-md-left mb-3">
                        <p class="mb-0 text-muted">Ao clicar no botão, você será guiado pelo processo de configuração da Meta para vincular seu número de WhatsApp Business na API Oficial*.</p>
                        <p class="mb-0 text-muted">Lembrando que só é possível conectar na opção "<u>Conectar um app do WhatsApp Business</u>".</p>
                      </b-col>
                      <b-col cols="12" md="4" class="text-center text-md-left mb-3 d-flex align-items-center">
                        <b-button variant="success" :disabled="fbIsConnecting" @click="launchEmbeddedSignup">
                          <i class="fab fa-whatsapp mr-1"></i> Iniciar configuração com a Meta
                        </b-button>
                      </b-col>
                    </template>
                    <template v-else-if="!fbFinishedConfiguration">
                      <b-col cols="12" class="text-center text-md-left mb-3">Finalize a configuração do seu número</b-col>
                      <b-col cols="12" md="8" class="text-center text-md-left mb-3">
                        <p class="mb-0 text-muted">Para habilitar o envio de mensagens, é necessário cadastrar uma forma de pagamento na sua conta do WhatsApp na Meta (Facebook).</p>
                        <p class="mb-0 text-muted">Caso ainda não tenha feito isso, utilize o botão para configurar.</p>
                      </b-col>
                      <b-col cols="12" md="4" class="text-center text-md-left d-flex align-items-center">
                        <a target="_blank" class="btn btn-primary" :href="'https://business.facebook.com/billing_hub/accounts/details/?business_id='+whatsappForm.business_id+'&asset_id='+whatsappForm.waba_id">
                          <i class="fas fa-external-link-alt mr-1"></i> Configurar forma de pagamento
                        </a>
                      </b-col>
                      <b-col cols="12" class="text-left mt-3">
                        <div class="d-flex align-items-start">
                          <div class="pretty p-switch p-fill mt-1 flex-shrink-0">
                            <input type="checkbox" v-model="fbConfiguredPaymentMethod" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                          <span class="configured-payment-method-label ml-2">Declaro que já configurei um meio de pagamento na Meta e estou ciente de que o Consulta Já não possui qualquer vínculo com o WhatsApp ou com a Meta Platforms Inc., sendo de minha exclusiva responsabilidade todos os custos decorrentes do envio de mensagens, bem como quaisquer prejuízos, falhas, interrupções, bloqueios ou banimentos aplicados pela Meta ao número conectado, isentando integralmente o Consulta Já de qualquer responsabilidade sobre tais ocorrências.</span>
                        </div>
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col cols="12" class="mb-3">
                        <p class="mb-2">Templates de mensagem</p>
                      </b-col>
                      <b-col cols="12">
                        <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj text-left">
                          <thead>
                          <tr>
                            <th>Tipo de mensagem</th>
                            <th>Nome do template</th>
                            <th>Categoria</th>
                            <th>Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="template in fbTemplates" :key="template.name">
                            <td>{{ template.description }}</td>
                            <td>{{ template.name }}</td>
                            <td>{{ template.category }}</td>
                            <td>{{ template.status }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </b-col>
                      <b-col cols="12" md="4" class="text-left" v-if="whatsappForm.whatsapp_phone_id !== '' || whatsappForm.whatsapp_phone_id != null">
                        <label class="cj-label">ID do número</label>
                        <b-form-input type="text" v-model="whatsappForm.whatsapp_phone_id" :disabled="true" autocomplete="off"></b-form-input>
                      </b-col>
<!--                      TODO algum link p/ solicitar revisao?-->
                    </template>
                  </b-row>

                  <hr class="mb-4">
                  <b-row class="mb-2">
                    <b-col cols="12" class="mb-0">Alerta de segurança</b-col>
                    <b-col class="d-flex align-items-end">
                      <label class="cj-label"><span style="color: #495057; font-size: 13px;">Em caso de desconexão do número, para que a entrega de mensagens não seja prejudicada, enviaremos uma mensagem de alerta no Whatsapp do número informado.</span></label>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Número de contato para alertas</label>
                      <validation-provider name="número de contato para alertas" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="whatsappForm.status_notification_cellphone" v-mask="'(##) #####-####'" :disabled="!((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <template v-if="whatsappForm.status === 'connected'">
                    <hr class="mb-3">
                    <b-row class="mb-2">
                      <b-col cols="12" md="6">
                        <label class="cj-label">Agendas</label>
                        <multiselect v-model="whatsappForm.agendas" :options="agendas" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :multiple="true" :disabled="!((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit))" placeholder="Agendas"></multiselect>
                      </b-col>
                    </b-row>
                  </template>
                </div>
                <div class="footer clearfix" v-if="((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit) || canRemove)">
                  <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((whatsappForm.id == null && canAdd && whatsappForm.accepted_terms) || (whatsappForm.id != null && canEdit && (!currently_using_official_api || whatsappForm.status !== 'connected' || fbFinishedConfiguration || fbConfiguredPaymentMethod)))" @click="saveWhatsapp">Salvar</b-button>
                  <b-button variant="danger" class="mr-3" v-if="whatsappForm.id != null && canRemove" @click="deleteWhatsapp">Excluir</b-button>
                  <b-button variant="danger" class="float-right" v-if="whatsappForm.id != null && whatsappForm.status != null && whatsappForm.status !== 'connecting' && whatsappForm.status !== 'disconnected' && canRemove" @click="disconnectWhatsapp">Desconectar</b-button>
<!--                  <b-button variant="warning" class="mr-3 float-right" v-if="whatsappForm.id != null && whatsappForm.status != null && whatsappForm.status !== 'connecting' && whatsappForm.status !== 'disconnected' && canRemove" @click="rebootWhatsapp">Reiniciar</b-button>-->
                </div>
              </div>
            </b-col>
            <b-col cols="12" v-if="whatsappForm.use_official_api">
              <small>*Os custos relacionados ao envio de mensagens via WhatsApp podem ser consultados diretamente na página oficial da Meta Platforms Inc., disponível <a href="https://developers.facebook.com/docs/whatsapp/pricing" target="_blank">clicando aqui</a>.</small>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: 'conta de Whatsapp',
        termPlural: 'contas de Whatsapp',
        url: 'configuracoes/contas-de-whatsapp',
        letter: 'a',
        newTerm: 'cadastrar-conta-de-whatsapp',
        module: 'whatsapps',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        interval: null,

        agendas: [],

        whatsappForm: {
          id: null,
          name: '',
          status_notification_cellphone: '',
          number: '',
          whatsapp_id: null,
          whatsapp_phone_id: null,
          qrcode: null,
          status: null,
          accepted_terms: true, //TODO mudar isso se voltar a usar a confirmacao
          use_official_api: true,
          waba_id: null,
          business_id: null,
          enabled: false,
          agendas: [],
        },
        currently_using_official_api: false,
        fbData: null,
        fbCode: null,
        fbMessageListener: null,
        fbIsConnecting: false,
        fbFinishedConfiguration: false,
        fbConfiguredPaymentMethod: false,
        fbTemplates: [],
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false || (this.user.person.client.mandic_campaign && this.user.person.client.mandic_campaign.trial_active === 0 && this.user.person.client.mandic_campaign.subscription_active === 0)) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;
      if(this.$route.params.id != this.newTerm) {
        this.loadFacebookSDK();

        await this.api.getWhatsapp(this.$route.params.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.whatsappForm = {
            id: res.data.item.id,
            name: res.data.item.name,
            status_notification_cellphone: res.data.item.status_notification_cellphone,
            number: res.data.item.number,
            whatsapp_id: null,
            whatsapp_phone_id: res.data.item.phone_id,
            qrcode: null,
            status: null,
            use_official_api: res.data.item.source === 'WhatsApp Oficial',
            waba_id: res.data.item.waba_id,
            business_id: res.data.item.business_id,
            enabled: res.data.item.enabled,
            agendas: []
          };
          this.currently_using_official_api = this.whatsappForm.use_official_api;

          if(res.data.status.id) {
            this.whatsappForm.whatsapp_id = res.data.status.id;
          }
          if(res.data.status.instance && res.data.status.instance.qrcode) {
            this.whatsappForm.qrcode = res.data.status.instance.qrcode;
          }
          if(res.data.status.instance && res.data.status.instance.status) {
            this.whatsappForm.status = res.data.status.instance.status;
            if(this.whatsappForm.status !== 'connected') {
              this.interval = setInterval(this.checkStatus, 10*1000);
            }
          }
          if(this.currently_using_official_api && this.whatsappForm.status === null) {
            this.setupMessageListener();
          }
          if(res.data.status.instance && typeof res.data.status.instance.finished_configuration != 'undefined') {
            this.fbFinishedConfiguration = res.data.status.instance.finished_configuration;
          }
          if(res.data.status.templates) {
            this.fbTemplates = res.data.status.templates;
          }
          this.agendas = [];
          res.data.agendas.forEach(agenda => {
            this.agendas.push({value: agenda.id, name: agenda.name});
          });

          if(this.agendas.length > 0) {
            res.data.item.agendas.forEach(agenda => {
              this.whatsappForm.agendas.push({value: agenda.id, name: agenda.name});
            });
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Whatsapp', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar esta ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Whatsapp', err.response);
        });
      } else {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
      }
    },
    methods: {
      loadFacebookSDK() {
        if (document.getElementById('facebook-jssdk')) {
          return;
        }

        window.fbAsyncInit = function() {
          window.FB.init({
            appId: process.env.VUE_APP_FACEBOOK_APP_ID,
            autoLogAppEvents: true,
            xfbml: true,
            version: process.env.VUE_APP_FACEBOOK_API_VERSION,
          });
        };

        const script = document.createElement('script');
        script.id = 'facebook-jssdk';
        script.async = true;
        script.defer = true;
        script.crossOrigin = 'anonymous';
        script.src = 'https://connect.facebook.net/pt_BR/sdk.js';
        document.head.appendChild(script);
      },

      setupMessageListener() {
        this.fbMessageListener = (event) => {
          if (!event.origin.endsWith('facebook.com')) {
            return;
          }

          try {
            const data = JSON.parse(event.data);
            if (data.type === 'WA_EMBEDDED_SIGNUP') {
              if (data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING') {
                this.fbData = data;
                this.connectOfficialWhatsapp();
                return;
              }
              if(['FINISH', 'FINISH_ONLY_WABA'].indexOf(data.event) >= 0) {
                //TODO offboard?
                //TODO ver o que acontece quando faz isso c/ uma conta real - continua deixando voltar a abrir e configurar?
                this.fbData = null;
                this.$swal('Ops...', 'A configuração feita não é suportada.<br>Por favor, configure novamente seguindo todas as instruções.', 'error');
              }
              // if (data.event === 'FINISH') {
              //   this.signupData.phoneNumberId = data.data.phone_number_id;
              //   this.signupData.wabaId = data.data.waba_id;
              // } else if (data.event === 'CANCEL') {
              //   this.canPerformAction = true;
              //   this.$swal('Cancelado', 'O processo de configuração foi cancelado.', 'info');
              // } else if (data.event === 'ERROR') {
              //   this.canPerformAction = true;
              //   this.$swal('Ops...', 'Ocorreu um erro durante a configuração. Por favor, tente novamente.', 'error');
              // }
            }
          } catch (e) {
            // Ignorar mensagens que não são JSON válido
            console.log('message event: ', event.data);
            this.fbIsConnecting = false;
          }
        };

        window.addEventListener('message', this.fbMessageListener);
      },

      launchEmbeddedSignup() {
        this.fbData = null;
        this.fbCode = null;
        if (!window.FB) {
          this.$swal('Ops...', 'A ferramenta da Meta (Facebook) ainda está carregando. Por favor, aguarde um momento e tente novamente.', 'warning');
          return;
        }

        this.fbIsConnecting = true;
        window.FB.login((response) => {
          this.fbIsConnecting = false;
          if (response.authResponse) {
            this.fbCode = response.authResponse.code;
            this.connectOfficialWhatsapp();
          }
        }, {
          config_id: process.env.VUE_APP_FACEBOOK_CONFIG_ID,
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            version: 'v4',
            setup: {
              business: {
                phone: {
                  code: 55,
                  number: '',
                },
                address: {
                  country: 'BR'
                },
                timezone: 'UTC-03:00'
              },
            },
            featureType: 'whatsapp_business_app_onboarding',
          }
        });
      },

      async saveWhatsapp() {
        if(!this.canPerformAction || !((this.whatsappForm.id == null && this.canAdd) || (this.whatsappForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let whatsappData = {
          id: this.whatsappForm.id,
          name: this.whatsappForm.name,
          status_notification_cellphone: this.whatsappForm.status_notification_cellphone,
          use_official_api: this.whatsappForm.use_official_api,
          configured_payment_method: this.fbConfiguredPaymentMethod
        };
        if(this.whatsappForm.status === 'connected') {
          whatsappData.agendas = this.whatsappForm.agendas.map(agenda => {
            return agenda.value;
          });
        }

        this.eventBus.$emit('IS_LOADING', true);
        if (this.whatsappForm.id == null) {
          this.api.storeWhatsapp(whatsappData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$router.push({path: '/'+this.url+'/'+res.data.id}).catch(() => {});
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Whatsapp', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos criar esta '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Whatsapp', err.response);
          });
        } else {
          this.api.updateWhatsapp(this.whatsappForm.id, whatsappData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 200) {
              if(this.whatsappForm.status === 'connected' && (!this.whatsappForm.use_official_api || this.fbFinishedConfiguration)) {
                this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi atualizada com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url}).catch(() => {});
                });
              }
              else {
                this.$router.push({path: '/'+this.url+'/'+this.whatsappForm.id}).catch(() => {});
              }
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Whatsapp', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            try {
              let msg = 'Não conseguimos atualizar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
            } catch(err2) {
              this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchUpdateWhatsapp\nError:'+err.toString(), 'warning');
              this.sentry.captureException(err);
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Whatsapp', err.response);
          });
        }
      },

      connectOfficialWhatsapp() {
        if (this.fbData === null || this.fbCode === null) {
          return;
        }

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        let whatsappData = {
          code: this.fbCode,
          phone_number_id: this.fbData.data.phone_number_id,
          waba_id: this.fbData.data.waba_id,
          business_id: this.fbData.data.business_id,
          event: this.fbData.event
        };

        this.api.connectOfficialWhatsapp(this.whatsappForm.id, whatsappData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.$swal('Uhull \\o/', 'Seu número foi conectado com sucesso na API Oficial do WhatsApp!<br>Finalize a configuração para poder utilizá-lo no sistema.', 'success');

          this.whatsappForm.status = 'connected';
          this.whatsappForm.waba_id = this.fbData.data.waba_id;
          this.whatsappForm.business_id = this.fbData.data.business_id;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Connect Official Whatsapp', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let response = err.response;
          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos registrar seu número na API Oficial! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Connect Official Whatsapp', err.response);
        });
      },

      async checkStatus() {
        this.api.checkWhatsappStatus(this.whatsappForm.id, {whatsapp_id: this.whatsappForm.whatsapp_id}).then(res => {
          if(this.leavingPage) {
            return;
          }
          if (res.status == 200) {
            this.whatsappForm.status = res.data.instance.status;

            if(res.data.number) {
              this.whatsappForm.number = res.data.number;
            }
            if(res.data.instance.status == 'connected') {
              this.whatsappForm.qrcode = null;
              this.clearTimer();
              this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi conectada com sucesso!', 'success');
            }
            else {
              this.whatsappForm.qrcode = res.data.instance.qrcode;
              if(res.data.id) {
                this.whatsappForm.whatsapp_id = res.data.id;
              }
            }
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Check Status', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos verificar o status desta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Check Status', err.response);
        });
      },

      async deleteWhatsapp() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.clearTimer();
            this.api.deleteWhatsapp(this.whatsappForm.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi excluída com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Whatsapp', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Whatsapp', err.response);
            });
          }
        }
      },

      async disconnectWhatsapp() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.disconnectWhatsapp(this.whatsappForm.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi desconectada com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao desconectar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Disconnect Whatsapp', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos desconectar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Disconnect Whatsapp', err.response);
            });
          }
        }
      },

      // async rebootWhatsapp() {
      //   if(this.canRemove) {
      //     let doCancel = false;
      //
      //     await this.$swal({
      //       title: 'Você tem certeza?',
      //       text: 'Esta ação não poderá ser desfeita!',
      //       type: 'warning',
      //       showCancelButton: true,
      //       confirmButtonText: 'OK',
      //       cancelButtonText: 'Cancelar',
      //       focusCancel: true
      //     }).then((res) => {
      //       if(res.value) {
      //         doCancel = true;
      //       }
      //     });
      //
      //     if(doCancel) {
      //       this.canPerformAction = false;
      //       this.eventBus.$emit('IS_LOADING', true);
      //       this.api.rebootWhatsapp(this.whatsappForm.id).then(res => {
      //         this.eventBus.$emit('IS_LOADING', false);
      //         this.canPerformAction = true;
      //         if (res.status == 204) {
      //           this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi reiniciada com sucesso!', 'success').then(() => {
      //             this.$router.go();
      //           });
      //         } else {
      //           this.$swal('Ops...', 'Ocorreu um erro ao reiniciar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
      //         }
      //
      //         if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //           console.log('Response Reboot Whatsapp', res);
      //       }).catch(err => {
      //         this.eventBus.$emit('IS_LOADING', false);
      //         this.canPerformAction = true;
      //         this.$swal('Ops...', 'Não conseguimos reiniciar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
      //         if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //           console.log('Error Reboot Whatsapp', err.response);
      //       });
      //     }
      //   }
      // },

      getStatus() {
        if(this.whatsappForm.status == 'connected') {
          if(this.currently_using_official_api && !this.whatsappForm.enabled) {
            return {name:'Conectado - Aguardando ' + (this.fbFinishedConfiguration ? 'aprovação dos templates' : 'finalização das configurações'), class: 'pending'};
          }
          return {name:'Conectado!', class: 'enabled'};
        }
        else if(this.whatsappForm.status == 'connecting') {
          return {name:'Aguardando leitura do QRCode/Conectando', class: 'pending'};
        }
        else if(this.whatsappForm.status == 'disconnected') {
          return {name:'Desconectado', class: 'deleted'};
        }
        // else if(whatsapp.status == 'deleted') {
        //   return {name:'Excluído', class: 'deleted'};
        // }
        // else {
        //   return {name:'Desabilitado', class: 'disabled'};
        // }
      },

      goBack() {
        this.$router.push({path: '/' + this.url}).catch(() => {});
      },

      clearTimer() {
        if(this.interval != null) {
          clearInterval(this.interval);
          this.interval = null;
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      this.clearTimer();
      if (this.messageListener) {
        window.removeEventListener('message', this.messageListener);
      }
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;

    .text1 {
      font-size: 14px;
      color: $cadetGray;
      margin-bottom: 0;
    }

    .configured-payment-method-label {
      font-size: 13px;
      color: #495057;
      line-height: 1.4;
    }

    .whatsapp-status {
      .status-indicator {
        font-size: 14px;

        &.enabled {
          color: $ufoGreen;
        }
        &.pending {
          color: $yellowSea;
        }
        &.deleted {
          color: $dullRed;
        }
        &.disabled {
          color: #333333;
        }
      }
    }

  }
</style>
